var React = require('react');

function Mark (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"fill":"#ff7e00","points":"0 0 122.33 324.1 122.33 0 0 0","key":0}),React.createElement("polygon",{"fill":"#e85e00","points":"122.33 0 122.33 324.1 244.67 0 122.33 0","key":1})]);
}

Mark.defaultProps = {"viewBox":"0 0 244.67 324.1"};

module.exports = Mark;

Mark.default = Mark;
